import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Navigate, useNavigate } from 'react-router';
import { useAppDispatch, useAppSelector } from 'store/store';
import { login } from 'store/actions/authActions';
import { CustomTextField } from 'components/FormFields/CustomTextField/CustomTextField';
import RedButton from 'Styled/RedButton';
import { isFulfilled } from '@reduxjs/toolkit';

const validationSchema = Yup.object({
  username: Yup.string().min(5, 'Mindestens 5 Zeichen').required('Benutzername ist erforderlich'),
  password: Yup.string().min(8, 'Mindestens 8 Zeichen').required('Passwort ist erforderlich'),
});

export const LoginPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, error } = useAppSelector((state) => state.auth);

  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <Box sx={{ width: 400, padding: 4, backgroundColor: '#fff', borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
        <Typography variant="h1" sx={{ marginBottom: 3, textAlign: 'center', fontSize: '24px' }}>
          PS-Sparen Anmeldung
        </Typography>

        {error && (
          <Alert severity="error" sx={{ marginBottom: 2 }}>
            {error.error}
          </Alert>
        )}

        <Formik
          initialValues={{ username: '', password: '' }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            const result = await dispatch(login(values));
            if (isFulfilled(result)) {
              navigate('/');
            }
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => (
            <Form>
              <Box sx={{ marginBottom: 2 }}>
                <CustomTextField autoComplete="username" name="username" label="Benutzername" value={values.username} onChange={handleChange} onBlur={handleBlur} error={touched.username && Boolean(errors.username)} helperText={touched.username ? errors.username : ''} />
              </Box>
              <Box sx={{ marginBottom: 3 }}>
                <CustomTextField autoComplete="current-password" name="password" label="Passwort" type="password" value={values.password} onChange={handleChange} onBlur={handleBlur} error={touched.password && Boolean(errors.password)} helperText={touched.password ? errors.password : ''} />
              </Box>
              <RedButton type="submit" fullWidth disabled={isSubmitting}>
                Anmelden
              </RedButton>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};
